import React, { useRef, useState } from "react";
import { Button, Typography, Box } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

function ImportWords({ selectedList, updateWordsList }) {
    const inputRef = useRef(null);
    const [fileName, setFileName] = useState("");

    const handleChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setFileName(file.name);

        const reader = new FileReader();

        reader.onload = (event) => {
            const words = event.target.result
                .split(/\r?\n/)
                .map(line => line.trim())
                .filter(Boolean);

            updateWordsList({
                name: selectedList.name,
                words
            });
        };

        reader.readAsText(file);
    };

    return (
        <Box display="flex" alignItems="center" mt={2}>
            <input
                ref={inputRef}
                type="file"
                accept=".txt"
                style={{ display: "none" }}
                onChange={handleChange}
            />

            <Button
                variant="contained"
                color="primary"
                startIcon={<CloudUploadIcon />}
                onClick={() => inputRef.current.click()}
            >
                Importer un fichier
            </Button>

            <Typography
                variant="body2"
                style={{ marginLeft: 16 }}
                color="textSecondary"
            >
                {fileName || "Aucun fichier sélectionné"}
            </Typography>
        </Box>
    );
}

export default ImportWords;